import { selectTrackingPromoSearch } from '../../selectors/tracking';
import { TThunkAction } from '../../types/redux/thunk';
import { trackPromoSearchClick } from '../../utils/analytics';

/**
 * Redux thunk action, который отправляет аналитику клика на поле с поиском в каталоге акций
 */
export const trackPromoSearchClickAction = (): TThunkAction<void> => {
  return (dispatch, getState) => {
    const state = getState();
    const params = selectTrackingPromoSearch(state);

    trackPromoSearchClick(params);
  };
};
